module.exports = __webpack_public_path__ + "static/media/header.b76e9578.png";